import React from 'react';
import { HistoryGrid } from '@1823-partners/core';
import { getFrequencyHistory } from '../api';

const FrequencyHistory = ({ id2 }) => (
  <HistoryGrid
    fetchHistory={() => getFrequencyHistory(id2)}
    fetchParams={[id2]}
    fieldNames={{ FREQUENCY: 'Frequency', NOTES: 'Notes' }}
    columns={[
      { field: 'FREQUENCY', headerName: 'Frequency', minWidth: 120 },
      { field: 'NOTES', headerName: 'Notes', minWidth: 200, flex: 1 },
    ]}
    showVersionColumn={false}
  />
);

export default FrequencyHistory;
